"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../../actions/types/types.generic");
function sourceOnProgram() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types.SOURCE_ON_PROGRAM) {
    return action.payload;
  }
  if (action.type === _types.RESET_SOURCE_ON_PROGRAM_STATE) {
    return null;
  }
  return state;
}
var _default = exports["default"] = sourceOnProgram;